<div class="fc-date-input" [class.invalid]="control.errors || hasGroupError">
  <div
    class="fc-date-input__infix"
    [class.fc-date-input__infix--filled]="control.value || control.errors?.matDatepickerParse?.text"
  >
    <label
      class="fc-date-input__infix-label"
      [class.fc-date-input__infix-label--error]="control.touched && control.errors"
      (click)="input.focus()"
    >
      <span *ngIf="label">{{ label }}</span>
      <span class="requiredSymbol" *ngIf="required">*</span>
    </label>
    <input
      class="fc-date-input__infix-input"
      tabindex="-1"
      #input
      [max]="max"
      [min]="min"
      [placeholder]="placeholder ? placeholder : ''"
      [(formControl)]="control"
      [matDatepicker]="matDatepicker"
    />
    <small class="fc-date-input__infix-error" *ngIf="control.errors && !hasGroupError">
      {{ translateErrorPrefix + '.' + (control | firstError) | translate }}
    </small>
  </div>
  <div class="fc-date-input__suffix" (click)="matDatepicker.open()">
    <mat-icon [ngClass]="colorIcon || fixedColor ? 'icon-valid' : 'icon-not-valid'"> event </mat-icon>
  </div>
</div>
<mat-datepicker #matDatepicker></mat-datepicker>
